import { trim } from 'lodash';

export function getWpUrl() {
  const wpUrl = trim(process.env.NEXT_PUBLIC_API_HOST, '/');

  return wpUrl;
}
